/* global axios */
import ApiClient from './ApiClient';

class KanbanNotesAPI extends ApiClient {
  constructor() {
    super('kanban_cards', { accountScoped: true });
  }

  list(cardId) {
    return axios.get(`${this.url}/${cardId}/notes`);
  }

  create(cardId, formData) {
    return axios.post(`${this.url}/${cardId}/notes`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(cardId, noteId, payload) {
    return axios.patch(`${this.url}/${cardId}/notes/${noteId}`, payload);
  }

  destroy(cardId, noteId) {
    return axios.delete(`${this.url}/${cardId}/notes/${noteId}`);
  }
}

export default new KanbanNotesAPI();
